import Gregorian_Date from "./Gregorian_Date";
import Gregorian_Datetime from "./Gregorian_Datetime";
import Hour_Time from "./Hour_Time";
import { gregorian_datetime_2_julian_datetime, gregorian_date_2_julian_date } from "./conversion";

export function getCurrentDate(): number {
	const d = new Date();
	const date = new Gregorian_Date(d.getFullYear(), d.getMonth() + 1, d.getDate());
	return gregorian_date_2_julian_date(date);
}

export function getCurrentDateAndTime(): number {
	const d = new Date();
	const date_time = new Gregorian_Datetime(
		new Gregorian_Date(d.getFullYear(), d.getMonth() + 1, d.getDate()),
		new Hour_Time(d.getHours(), d.getMinutes(), d.getSeconds())
	);
	return gregorian_datetime_2_julian_datetime(date_time);
}
